<template>
  <div class="has-integration-types-component">
    <div class="column is-12">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-1 is-size-2-tablet is-size-3-mobile has-text-centered has-text-grey-dark dm-sans">
            Qual tipo de integração você deseja?
          </p>
        </div>
      </div>
      
      <!-- Versão mobile: layout vertical -->
      <div class="columns is-multiline is-hidden-desktop">
        <!-- Cloud (Mobile) -->
        <div class="column is-full mb-5">
          <div class="buttons is-flex is-justify-content-center is-full">
            <button
                class="button is-grey is-size-4-tablet is-size-5-mobile has-text-weight-bold mx-2 is-fullwidth"
                @click.prevent="setIntegrationType('cloud')"
            >
              <span>
                Integração Cloud
              </span>
            </button>
          </div>
          <div class="buttons is-flex is-justify-content-center is-full mt-3">
            <span class="is-size-5-tablet is-size-6-mobile has-text-centered has-text-grey-dark has-text-weight-bold dm-sans mb-2">
              Diferenças integrações
            </span>
          </div>
          <integration-diff-table integration-type="cloud"></integration-diff-table>

          <div class="buttons is-flex is-justify-content-center is-full mt-4">
            <span class="is-size-5-tablet is-size-6-mobile has-text-grey-dark has-text-weight-bold dm-sans">
              Funções Inclusas
            </span>
          </div>
          <integration-functions-diff-table integration-type="cloud"></integration-functions-diff-table>
        </div>

        <!-- Web (Mobile) -->
        <div class="column is-full mt-5">
          <div class="buttons is-flex is-justify-content-center is-full">
            <button
                class="button is-grey is-size-4-tablet is-size-5-mobile has-text-weight-bold mx-2 is-fullwidth"
                @click.prevent="setIntegrationType('web')"
            >
              <span>Integração Web</span>
            </button>
          </div>
          <div class="buttons is-flex is-justify-content-center is-full mt-3">
            <span class="is-size-5-tablet is-size-6-mobile has-text-centered has-text-grey-dark has-text-weight-bold dm-sans mb-2">
              Diferenças integrações
            </span>
          </div>
          <integration-diff-table integration-type="web"></integration-diff-table>

          <div class="buttons is-flex is-justify-content-center is-full mt-4">
            <span class="is-size-5-tablet is-size-6-mobile has-text-grey-dark has-text-weight-bold dm-sans">
              Funções Inclusas
            </span>
          </div>
          <integration-functions-diff-table integration-type="web"></integration-functions-diff-table>
        </div>
      </div>
      
      <!-- Versão desktop: layout horizontal -->
      <div class="columns is-hidden-touch">
        <div class="column is-half">
          <div class="buttons is-flex is-justify-content-center is-full">
            <button
                class="button is-grey is-size-3 has-text-weight-bold mx-4 is-fullwidth"
                @click.prevent="setIntegrationType('cloud')"
            >
              <span>
                Integração Cloud
              </span>
            </button>
          </div>
          <div class="buttons is-flex is-justify-content-center is-full">
            <span class="is-size-4 has-text-centered has-text-grey-dark has-text-weight-bold dm-sans mb-4">
              Diferenças integrações
            </span>
            <integration-diff-table integration-type="cloud"></integration-diff-table>
          </div>

          <div class="buttons is-flex is-justify-content-center is-full">
            <span class="is-size-4 has-text-grey-dark has-text-weight-bold dm-sans">
              Funções Inclusas
            </span>
          </div>
          <div class="buttons is-flex is-justify-content-center is-full">
            <integration-functions-diff-table integration-type="cloud"></integration-functions-diff-table>
          </div>
        </div>

        <div class="column is-half">
          <div class="buttons is-flex is-justify-content-center is-full">
            <button
                class="button is-grey is-size-3 has-text-weight-bold mx-4 mb-5 is-fullwidth"
                @click.prevent="setIntegrationType('web')"
            >
              <span>Integração Web</span>
            </button>
          </div>
          <div class="buttons is-flex is-justify-content-center is-full mt-6">
            <integration-diff-table integration-type="web"></integration-diff-table>
          </div>

          <div class="buttons is-flex is-justify-content-center is-full mt-6 pt-5">
            <integration-functions-diff-table integration-type="web"></integration-functions-diff-table>
          </div>
        </div>
      </div>
      
      <div class="integrationTable" v-if="showIntegrationTypes">
        <div class="columns mt-4">
          <div class="column is-full">
            <p class="is-size-1 is-size-2-tablet is-size-3-mobile has-text-centered has-text-grey-dark dm-sans">
              Qual?
            </p>
          </div>
        </div>
        <div class="columns mt-4">
          <div class="column is-full is-flex is-justify-content-center is-align-content-center">
            <div class="select is-large is-primary is-one-quarter-desktop is-half-tablet is-full-mobile">
              <select class="has-text-centered" v-model="formData.partner.data">
                <option disabled selected>Selecionar</option>
                <option :value="partner" v-for="(partner, index) in partners" :key="index">
                  {{ partner.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12 pt-6" v-if="formData.partner.data && formData.partner.data.id">
      <next-button
          @nextTab="$emit('nextTab')"
          position="right"
          sizeClass="is-one-third is-fullwidth-mobile"
      ></next-button>
    </div>
  </div>
</template>

<script>

import NextButton from './NextButton'
import IntegrationDiffTable from "./IntegrationDiffTable";
import IntegrationFunctionsDiffTable from "./IntegrationFunctionsDiffTable";

export default {

  name: 'integrationTypes',

  data() {
    return {
      showIntegrationTypes: false
    }
  },

  components: {
    NextButton,
    IntegrationDiffTable,
    IntegrationFunctionsDiffTable
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  methods: {
    setIntegrationType(type) {
      this.formData.integration.data.type = type
      this.$emit('nextTab')
      this.$emit('getPlans')
    }
  }

}

</script>

<style lang="scss" scoped>
.has-integration-types-component {
  overflow-x: hidden;
  width: 100%;
  
  button {
    transition: all 0.3s ease;
    
    &:hover, &:focus {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    }
  }
}

@media screen and (max-width: 768px) {
  .has-integration-types-component {
    .is-size-3-mobile {
      font-size: 1.5rem !important;
    }
    
    .is-size-5-mobile {
      font-size: 1rem !important;
    }
    
    .is-size-6-mobile {
      font-size: 0.9rem !important;
    }
    
    .mx-2 {
      margin-left: 0.5rem !important;
      margin-right: 0.5rem !important;
    }
    
    .mb-2 {
      margin-bottom: 0.5rem !important;
    }
    
    .mb-5 {
      margin-bottom: 1rem !important;
    }
    
    .mt-3 {
      margin-top: 0.75rem !important;
    }
    
    .mt-4 {
      margin-top: 1rem !important;
    }
    
    .mt-5 {
      margin-top: 1.25rem !important;
    }
    
    .select {
      width: 100%;
      max-width: 90%;
      
      select {
        width: 100%;
        font-size: 1rem;
      }
    }
    
    .is-large {
      font-size: 1rem;
    }
    
    .pt-6 {
      padding-top: 1rem !important;
    }
    
    .buttons {
      margin-bottom: 0.5rem;
    }
  }
}
</style>
